import { useEffect, useRef } from 'react';

import { useUserCommunicationsStore } from '../../store';
import { useFetchCacheStore } from '../../store/FetchCache';

export const useEmailFilterResetEffect = (
  fetchEmailFilters: string[] | undefined,
) => {
  const { resetStateForFilterChange } = useUserCommunicationsStore();
  const { invalidateAllViewTypes } = useFetchCacheStore();

  const prevSerializedRef = useRef(JSON.stringify(fetchEmailFilters));
  useEffect(() => {
    const serialized = JSON.stringify(fetchEmailFilters);
    if (serialized !== prevSerializedRef.current) {
      resetStateForFilterChange();
      invalidateAllViewTypes();
      prevSerializedRef.current = serialized;
    }
  }, [fetchEmailFilters, resetStateForFilterChange, invalidateAllViewTypes]);
};
